import { hsl } from 'polished';
export default {
    /** Hex: #000000 */
    black: '#000000',
    /** Hex: #fff */
    white: '#fff',
    primary: {
        /** Hex: #E2DBD4 */
        beigeLight: '#E2DBD4',
        /** Hex: #B4A593 */
        beige: '#B4A593',
        /** Hex: #424449 */
        textLight: '#424449',
        /** Hex: #181818 */
        darkGrey: '#181818',
    },
    secondary: {
        /** Hex: #B12024 */
        red: '#B12024',
    },
    grey: {
        /** Hex: #222222 */
        grey13: hsl(0, 0, 0.13),
        /** Hex: #585858 */
        grey20: hsl(0, 0, 0.2),
        /** Hex: #585858 */
        grey35: hsl(0, 0, 0.35),
        /** Hex: #666666 */
        grey40: hsl(0, 0, 0.4),
        /** Hex: #707070 */
        grey44: hsl(0, 0, 0.44),
        /** Hex: #999999 */
        grey60: hsl(0, 0, 0.6),
        /** Hex: #CCCCCC */
        grey80: hsl(0, 0, 0.8),
        /** Hex: #E5E5E5 */
        grey90: hsl(0, 0, 0.9),
        /** Hex: #F7F7F7 */
        grey97: hsl(0, 0, 0.97),
    },
};
